<ul>
  <li *ngFor="let entry of entries; let i = index">
    <quick-order-product-item [entry]="entry" [form]="form"></quick-order-product-item>
  </li>
</ul>
